import { ISyncOptions } from '@/utils/ISyncOptions';
import { usersStore } from './store/users.store';
import { rolesStore } from './store/roles.store';

export default {
  preStartup: async (): Promise<void> => {
    await usersStore.getters.getAll();
    await rolesStore.getters.getAll();
  }
} as ISyncOptions;